<template>
    <div class="f fv ath-popover-filter-root">
        <header class="f fh fa-c">
            <h4 class="f fh fa-c fg">
                <span>{{ uiTitle | athT }}</span>
            </h4>
            <ButtonIcon icon="cross" @click="close" class="el--s-s" />
        </header>
        <div class="sp-t-s sp-b-xl ath-popover-filter-body" :class="[uiBodyClass]">
            <slot name="body"></slot>
        </div>
        <footer class="f fh fj-sb">
            <AthButton class="el--inline el--t-secondary el--s-s" @click="apply" lbl="mead.labels.apply" />
            <ButtonV2 :link="true" label="mead.labels.clear" @click="clear" />
        </footer>
    </div>
</template>

<script>
import ButtonIcon from '../../atoms/ButtonIcon.vue';
import AthButton from '../../atoms/Button.vue';
import ButtonV2 from '../../atoms/ButtonV2.vue';

export default {
    name: 'mead-filter-popover',
    props: {
        /**
         * Title text (i18n key) displayed in the popover's header.
         */
        uiTitle     : {type: String, default: () => 'mead.labels.filters'},
        /**
         * CSS class(es) applied to the popover body wrapper, used to control the layout of the
         * filter controls placed in the "body" slot.
         */
        uiBodyClass : {type: String, default: () => 'f fw'},
    },
    components: {ButtonIcon, AthButton, ButtonV2},
    methods: {
        close: function () {
            MeadCommon.PopoverService.close();
        },
        clear: function () {
            this.$emit('actClear');
        },
        apply: function () {
            this.$emit('actApply');
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

.ath-popover-filter-root {
    max-width: 30rem;
    min-width: 20rem;

    @media screen and (max-width: $mq-ds) {
        max-width: initial !important;
        width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        padding: $s-l;
        padding-top: calc(#{$s-l} + constant(safe-area-inset-top));
        padding-top: calc(#{$s-l} + env(safe-area-inset-top));
        background-color: var(--c-panel-bg);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: calc(#{$zx-page-overlay} + 1);

        .ath-popover-filter-body {
            flex-grow: 1;
            overflow-y: auto;
            width: calc(100% + (#{$s-l} * 2));
            transform: translateX(-$s-l);
            padding: 0 $s-l;
            margin: $s-s 0;
        }
    }
}

h4 {
    font-family: $ff-b;
    font-size: $fs-l;
}
</style>
